module.exports = __webpack_public_path__ + "static/media/close.c4b68c2b.svg";